import NormalRank from './NormalRank.js'
import DoubleRank from './DoubleRank.js'
import RoomRank from './RoomRank.js'
import TeamRank from './TeamRank.js'
import { props } from './props';
import { defineComponent } from '../utils/create';
export default defineComponent({
  name: 'CbRank',
  components: {
    NormalRank,
    DoubleRank,
    RoomRank,
    TeamRank
  },
  inheritAttrs: false,
  props,
  methods: {
    getRankType(type) {
      switch (type) {
        case 'double':
          return 'DoubleRank';
        case 'room':
          return 'RoomRank';
        case 'team':
          return 'TeamRank';
        default:
          return 'NormalRank';
      }
    }
  },
  render(h) {
    var componentType = this.getRankType(this.$attrs.type);
    return h(componentType, {
      props: this.$attrs,
      on: this.$listeners,
      // 透传插槽
      scopedSlots: this.$scopedSlots,
      slots: this.$slots
    });
  }
});